const data = [
	{ option: "Loading" },
	{ option: "Loading" },
	{ option: "Loading" },
	{ option: "Loading" },
];

export default data;
